module.exports = __webpack_public_path__ + "static/media/video.9e782c37.svg";